export const SET_SEGUTIMER = (state, payload) => {
    state.seguTimer = payload;
}

export const SET_MUGU_TIMER = (state, payload) => {
    state.muguTimer = payload;
}

export const SET_GURU_APPROVE_TIMER = (state, payload) => {
    state.guruApproveTimer = payload;
}

export const SET_GURU_QUEUE_TIMER = (state, payload) => {
    state.guruQueueTimer = payload;
}

export const SET_SETEN_TIMER = (state, payload) => {
    state.setenTimer = payload;
}

export const SET_MUTEN_TIMER = (state, payload) => {
    state.mutenTimer = payload;
}

export const SET_TENDIK_APPROVE_TIMER = (state, payload) => {
    state.tendikApproveTimer = payload;
}

export const SET_TENDIK_QUEUE_TIMER = (state, payload) => {
    state.tendikQueueTimer = payload;
}

export const SET_GUKEL_TIMER = (state, payload) => {
    state.gukelTimer = payload;
}

export const SET_SEMUA_GUKEL_TIMER = (state, payload) => {
    state.segukelTimer = payload;
}

export const SET_TENKEL_TIMER = (state, payload) => {
    state.tenkelTimer = payload;
}

export const SET_SEMUA_TENKEL_TIMER = (state, payload) => {
    state.setenkelTimer = payload;
}

export const SET_SEMUA_MUGU_TIMER = (state, payload) => {
    state.semuguTimer = payload;
}

export const SET_SEMUA_MUTEN_TIMER = (state, payload) => {
    state.semutenTimer = payload;
}